// AI-ASSISTED: generated with claude-code on 2026-08-17, reviewed by Yoann Hertienne
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useEntity } from '@backstage/plugin-catalog-react';
import { TileBoundary } from '../team-landing/TileBoundary';

// A single annotation holding the full deep link to the team's Azure
// performance dashboard (Azure Monitor / App Insights workbook / custom
// dashboard). Link-out only — same shape as the Rovo / LeanIX cards (DPT-491).
const DASHBOARD_ANNOTATION = 'luminus.be/performance-dashboard-url';

const PerformanceDashboardCardBody = () => {
  const { entity } = useEntity();
  const dashboardUrl = entity.metadata.annotations?.[DASHBOARD_ANNOTATION];

  // Hide the card when the component declares no dashboard (spec FR-008).
  if (!dashboardUrl) return null;

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6">Performance dashboard</Typography>
        <Typography variant="body2" color="text.secondary">
          Azure performance dashboard for this component.
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          variant="outlined"
          size="small"
          href={dashboardUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="Open Performance Dashboard for this component (opens in a new tab)"
        >
          Open Performance Dashboard
        </Button>
      </CardActions>
    </Card>
  );
};

export const PerformanceDashboardCard = () => (
  <TileBoundary tool="Performance dashboard">
    <PerformanceDashboardCardBody />
  </TileBoundary>
);
